
import React from "react";

export type ContentTitleProps = {
    title: string;
};

function ContentTitle(props: ContentTitleProps) {

    return (<div className="content-title">
        <span>{props.title}</span>
    </div>);
}

export default ContentTitle;
